<template>
  <div class="relative flex flex-col w-full h-full bg-white safe-area justify-between">
    <div class="head" :style="headStyle">
      <div class="absolute left-0 p-3">
        <slot name="leftBtn" />
      </div>
      <div class="font-semibold text-xl md:text-2xl" :class="{ uppercase: headUppercase }">
        <slot name="title" />
        {{ headText }}
      </div>
      <div class="absolute right-0 p-3">
        <slot name="rightBtn" />
      </div>
    </div>
    <!--
      canScroll used to sit on the root, which also carries .safe-area. A root
      that both scrolls and holds the insets as padding cannot absorb them —
      its height is pinned by the #app flex chain, so the padding lands in
      scrollHeight and becomes a scrollbar exactly as tall as the insets.
      Scroll the content area instead; the padding then sits outside the
      scroll container where it belongs.
    -->
    <div class="body flex flex-col" :class="{ 'overflow-y-auto': canScroll }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headUppercase: Boolean,
    headText: String,
    headStyle: String,
    canScroll: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.head {
  @apply relative flex justify-center items-center w-10/12 mx-auto my-5;
  height: 30px;
  z-index: 1;
  @screen md {
    @apply my-10;
    width: 87%;
  }
}

.body {
  flex: 1;
  // Without this a flex item refuses to shrink below its content, so the
  // content area would push past the root instead of scrolling inside it.
  min-height: 0;
}
</style>
